import { render } from "./CustomerSegmentEdit.vue?vue&type=template&id=72c3125d&scoped=true"
import script from "./CustomerSegmentEdit.vue?vue&type=script&lang=js"
export * from "./CustomerSegmentEdit.vue?vue&type=script&lang=js"

import "./CustomerSegmentEdit.vue?vue&type=style&index=0&id=72c3125d&lang=scss&scoped=true"
import "./CustomerSegmentEdit.vue?vue&type=style&index=1&id=72c3125d&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c3125d"]])

export default __exports__